import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalKcsComponent } from './kcs-modal';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MultiSelectModule } from 'primeng/multiselect';
import { SafeHtmlPipe } from 'src/app/pipe/safe-html.pipe';
import { ButtonModule } from 'primeng/button';

@NgModule({
	imports: [CommonModule, FormsModule, NgbModule, MultiSelectModule, ButtonModule],
	declarations: [ModalKcsComponent, SafeHtmlPipe],
	exports: [ModalKcsComponent],
	providers: [NgbActiveModal],
})
export class ModalKcsModule {}
